var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{attrs:{"span":_vm.widgetConfig.span || 24}},[_c('img',{staticStyle:{"max-width":"100%"},style:(_vm.getImageStyle),attrs:{"src":_vm.widgetConfig.src,"height":_vm.widgetConfig.height,"width":_vm.widgetConfig.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }